import React from 'react';
import { Button } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import IconButton from 'components/common/IconButton';

const buildSimpleButton = (button) => {
  return (
    <Button
      key={button.name}
      type={button.type}
      size="sm"
      onClick={button.onClick}
      variant={button.variant || variant || 'outline-primary'}
      className="w-100 w-md-auto me-1 mb-2"
    >
      {button.name}
    </Button>
  );
};
const buildIconButton = (button) => {
  return (
    <IconButton
      key={button.name}
      type={button.type}
      onClick={button.onClick}
      variant={button.variant || variant || 'falcon-default'}
      className="w-100 w-md-auto me-1 mb-2"
      size="sm"
      icon={button.icon}
      iconAlign="left"
      transform="shrink-3"
    >
      {button.name}
    </IconButton>
  );
};

function useHeaderGenerator(title, description, buttons) {
  return (
    <PageHeader title={title} description={description} className="mb-3">
      {buttons.map((button) => {
          if (button.icon !== undefined) {
            return buildIconButton(button);
          } else {
            return buildSimpleButton(button);
          }
        })}
    </PageHeader>
  );
}

export default useHeaderGenerator;
